export function downloadFileFromUrl(url: string, fileName: string): Promise<void> {
  //https://stackoverflow.com/questions/78208139/javascript-anchor-file-download-override-file-name-from-content-disposition-he
  return fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();

      // Revoke the object URL after a short delay to ensure the download starts
      // This frees up memory by releasing the blob reference
      setTimeout(() => URL.revokeObjectURL(url), 100);
    });
}
